module.exports = __webpack_public_path__ + "static/media/eclipse.fdd09bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/classes/eclipse.png
// module id = 644
// module chunks = 0